export default class Overlay extends google.maps.OverlayView {

    constructor ($el, map) {
        super();
        this.$el = $el;
        this.setMap(map);
        this.observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                if (mutation.type === 'attributes' && mutation.target.parentNode === $el) return this.render(mutation.target);
                if (mutation.type === 'childList' && mutation.target === $el) mutation.addedNodes.forEach(node => this.render(node));
            });
        });
    }

    onAdd () {
        this.getPanes().overlayMouseTarget.appendChild(this.$el);
        this.observer.observe(this.$el, {
            childList: true,
            attributes: true,
            subtree: true,
            attributeFilter: ['lat', 'lng']
        });
    }

    onRemove () {
        google.maps.event.clearInstanceListeners(this.$el);
        this.observer.disconnect();
        this.observer = null;
        this.$el.parentNode.removeChild(this.$el);
        this.$el = null;
    }

    render (node) {
        if (!(node instanceof HTMLElement)) return;
        const lat = node.getAttribute('lat');
        const lng = node.getAttribute('lng');
        const coords = new google.maps.LatLng(lat, lng);
        const point = this.getProjection().fromLatLngToDivPixel(coords);
        node.style.left = point.x + 'px';
        node.style.top = point.y + 'px';
        google.maps.OverlayView.preventMapHitsFrom(node);
    }

    draw () {
        Array.from(this.$el.children).forEach(node => this.render(node));
    }

}